import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetSeriesDetail = () => {
	const navigate = useNavigate()
	const {idx} = useParams()
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/series/${idx}`

		fetchRequest('GET', url)
	}, [])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'series_idx')
					setAlert('대회 시리즈 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('대회 시리즈 데이터가 존재하지 않습니다.')
					navigate('/series')
				}
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetSeriesDetail
